module.exports = __webpack_public_path__ + "static/media/crocodile.1fac8342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/crocodile.jpg
// module id = 229
// module chunks = 0